import { defineFetch } from 'resift';

const makeGetSource = defineFetch({
  displayName: 'Get Source',
  make: sourceId => ({
    request: () => ({ http }) =>
      http({
        method: 'GET',
        route: `/sources/${sourceId}`,
        query: { expand: ['fields', 'authorizationStatus', 'groups'] },
      }),
  }),
});

export default makeGetSource;
